jest.mock('./EventStrategies');
import { TriggerEvent } from './TriggerEvent';
import { OnEventTriggered, EventStrategyResolver, OnEventTriggeredEvent } from './EventStrategies';
import { mock, MockProxy } from 'jest-mock-extended';
import { PageEvent, PageEventProps, PageEventStrategy } from './EventStrategies/PageEventStrategy';
import { WorkflowContext } from '@samelogic/steps';
import { contextFactory } from '../../__tests__/factories';

const mockedResolver = <jest.Mock<EventStrategyResolver>>EventStrategyResolver;
beforeEach(() => {
  // Clear all instances and calls to constructor and all methods:
  mockedResolver.mockClear();
});
describe('TriggerEvent', () => {
  const context: WorkflowContext = contextFactory.build();
  let triggerEvent: TriggerEvent;

  const props: PageEventProps = {
    id: 'test-id',
    event: 'PageView',
    urlPattern: 'https://samelogic.com/*/test'
  };

  let mockEventStrategy: MockProxy<PageEventStrategy>;
  beforeEach(() => {
    mockEventStrategy = mock<PageEventStrategy>();
    mockedResolver.mockImplementation(() => {
      return { resolveStrategyByEventType: () => mockEventStrategy };
    });
  });

  describe('when started', () => {
    beforeEach(() => {
      triggerEvent = new TriggerEvent(context, props);
      triggerEvent.start();
    });
    it('should start the strategy', () => {
      expect(mockEventStrategy.start).toBeCalled();
    });
    describe('when event is triggered', () => {
      const eventData: OnEventTriggeredEvent<PageEventProps, PageEvent> = {
        condition: true,
        props: props,
        data: { href: 'https://test' }
      };
      const onTriggerChangeMock = jest.fn<OnEventTriggered<PageEventProps, unknown>, [unknown]>();
      beforeEach(() => {
        triggerEvent.onChanged = onTriggerChangeMock;
        mockEventStrategy.onEventTriggered?.(eventData);
      });
      it('should fire the onChanged event', () => {
        expect(onTriggerChangeMock).toBeCalledWith(eventData);
      });
    });
  });
});
